var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.editable)?_c('va-select-input',{attrs:{"color":"yellow","source":"scopes","multiple":""}}):_c('v-chip-group',_vm._l((_vm.scopes),function(item,i){return _c('v-chip',{key:i,attrs:{"color":"yellow","small":_vm.small}},[_c('va-select-field',{attrs:{"source":"scopes","item":item}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }